//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import SuccessDialog from "@/components/cards/SuccessDialog";
import html2pdf from "html2pdf.js";
import VueHtml2pdf from "vue-html2pdf";
import unity from "@/unity/unity";
import moment from "moment";

export default {
    name: "approve-leave-confirm",
    components: { SuccessDialogPush, SuccessDialog, VueHtml2pdf },
    data(vm) {
        return {
            str_m_time: "",
            end_m_time: "",
            image_show: "",
            day_select: "multiple",
            leave_hours: [
                { text: "1 hour", value: 1 },
                { text: "2 hours", value: 2 },
                { text: "3 hours", value: 3 },
                { text: "Half day", value: 4 },
                { text: "5 hours", value: 5 },
                { text: "6 hours", value: 6 },
                { text: "7 hours", value: 7 },
                { text: "Full day", value: 8 },
            ],
            menu_start: false,
            menu_end: false,
            leave_start_hours: "",
            leave_end_hours: "",
            dialogConfirm: false,
            approve_end_flow_status: false,
            approve_detail_data: [],
            imageshowpopup: "",
            fullName: "",
            employee_id: "",
            dialogDelete: false,
            dialogSave: false,
            dialogReject: false,
            preview: null,
            image: null,
            preview_list: [],
            oldpreview_list: [],
            image_list: [],
            menu: false,
            menu2: false,
            search: "",
            toggleEnable: false,
            selectstatus: "",
            dropdownLeave: [],
            dataAll: [],
            mDataArray: [],
            amountShow: "",
            leave_data: {
                leaveType: 0,
                leaveTypeId: 0,
                approve_id_now: 0,
                startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10),
                endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10),
                description: "",
                description_approve: "",
                status_approve_name: "",
                userId: 0,
                departmentId: 0,
                companyId: 0,
                amount: 0,
                images: null,
                lq_id: 0,
            },
            dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),

            dialogAdd: false,
            text_color: "text-h5 green--text text-center",
            title: "green",
            message: "green",
            link: "",
            profileImage: "",
            amountHours: 0, // ชั่วโมงลารวม (ใช้แสดงผล)
            requestRaw: {}, // แถวแรกจาก getLeaveHistoryByIDWaiting
            waitingRows: [], // ทุกแถว (1 แถวต่อผู้อนุมัติ) ใช้ทำ timeline
        };
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },
    computed: {
        // ===== UI ใหม่ =====
        backText() {
            return this.$route.params.mode == "approverhistory" ? "Back to approval history" : "Back to time off";
        },
        statusKey() {
            const s = String(this.leave_data.status_approve_name || "").toLowerCase();
            if (s.includes("approve")) return "success";
            if (s.includes("reject")) return "danger";
            if (s.includes("cancel")) return "info";
            return "warning";
        },
        statusChipClass() {
            return "rq-chip-" + this.statusKey;
        },
        statusIcon() {
            return {
                success: "mdi-check-circle-outline",
                danger: "mdi-close-circle-outline",
                info: "mdi-cancel",
                warning: "mdi-clock-outline",
            }[this.statusKey];
        },
        statusIconColor() {
            return { success: "#2E7D32", danger: "#C62828", info: "#2A5F8F", warning: "#E08A1E" }[this.statusKey];
        },
        leaveTypeIcon() {
            const t = String(this.leave_data.leaveTypeId || "").toLowerCase();
            if (t.includes("sick")) return { icon: "mdi-thermometer", color: "#3C8D4F", bg: "#EAF4EC" };
            if (t.includes("vacation")) return { icon: "mdi-palm-tree", color: "#2A6F97", bg: "#EAF2F8" };
            if (t.includes("personal") || t.includes("business"))
                return { icon: "mdi-account-outline", color: "#6B4FA0", bg: "#F0ECF7" };
            return { icon: "mdi-calendar-blank-outline", color: "#6B7280", bg: "#F1F3F5" };
        },
        totalText() {
            const t = Number(this.amountHours) || 0;
            if (t <= 0) return this.amountShow || "-";
            const d = Math.floor(t / 8);
            const h = Math.round((t - d * 8) * 100) / 100;
            if (d === 1 && h === 0) return "1 day";
            const parts = [];
            if (d > 0) parts.push(`${d} ${d === 1 ? "day" : "days"}`);
            if (h > 0) parts.push(`${h} ${h === 1 ? "hour" : "hours"}`);
            return parts.join(" ");
        },
        summaryDateText() {
            const a = this.displayDate(this.leave_data.startDate);
            if (this.day_select === "single") return a;
            const b = this.displayDate(this.leave_data.endDate);
            return a === b ? a : `${a} - ${b}`;
        },
        // ===== ข้อมูลพนักงาน (แสดงเมื่อ API ส่งมา) =====
        employeeCode() {
            const x = this.requestRaw || {};
            return x.employee_code || "";
        },
        departmentName() {
            const x = this.requestRaw || {};
            return x.department_name || "";
        },
        positionName() {
            const x = this.requestRaw || {};
            return x.position_name || "";
        },
        requestedText() {
            const x = this.requestRaw || {};
            const raw = x.created_at;
            if (!raw) return "";
            const m = moment(raw);
            return m.isValid() ? m.format("D MMM YYYY, HH:mm") : "";
        },
        totalChipText() {
            const t = Number(this.amountHours) || 0;
            const d = Math.floor(t / 8);
            const h = Math.round((t - d * 8) * 100) / 100;
            return `${d} ${d === 1 ? "day" : "days"} · ${h} ${h === 1 ? "hour" : "hours"}`;
        },
        durationText() {
            if (this.day_select === "single") return this.hoursText(this.leave_start_hours);
            if (this.day_select === "multiple")
                return `${this.hoursText(this.leave_start_hours)} / ${this.hoursText(this.leave_end_hours)}`;
            if (this.str_m_time || this.end_m_time) return `${this.str_m_time || "-"} - ${this.end_m_time || "-"}`;
            return this.totalText;
        },
        // ===== ขั้นตอนการอนุมัติ (ใช้ field lad_* ที่ backend ส่งมา) =====
        approvalSteps() {
            const seen = {};
            const steps = [];
            (this.waitingRows || []).forEach((r) => {
                if (r.lad_id === undefined || r.lad_id === null || seen[r.lad_id]) return;
                seen[r.lad_id] = true;
                steps.push(r);
            });
            return steps.sort((a, b) => Number(a.lad_id) - Number(b.lad_id));
        },
        // note ของผู้อนุมัติ "คนล่าสุดที่ตัดสิน" (กรณีมีหลายคน)
        // ไม่มีข้อมูลรายขั้น -> ใช้ค่าเดิม leave_data.description_approve
        approverNote() {
            const steps = this.approvalSteps;
            if (!steps.length) return this.leave_data.description_approve || "";
            const decided = steps.filter((r) => [2, 3].includes(Number(r.lad_status)) && String(r.remark_detail || "").trim());
            return decided.length ? decided[decided.length - 1].remark_detail : "";
        },
        // label บนการ์ด Decision เมื่อมีผู้อนุมัติหลายคน
        approverNoteLabel() {
            const steps = this.approvalSteps;
            const decided = steps.filter((r) => [2, 3].includes(Number(r.lad_status)) && String(r.remark_detail || "").trim());
            if (steps.length > 1 && decided.length) {
                const last = decided[decided.length - 1];
                return `Note from ${this.approverName(last, steps.indexOf(last))}`;
            }
            return "Note from approver";
        },
        currentApproverName() {
            const steps = this.approvalSteps;
            const pending = steps.findIndex((r) => Number(r.lad_status) === 1);
            if (this.statusKey === "warning" && pending !== -1) return this.approverName(steps[pending], pending);
            const done = [...steps].reverse().find((r) => [2, 3].includes(Number(r.lad_status)));
            return done ? this.approverName(done, steps.indexOf(done)) : "";
        },
        decisionSubText() {
            const steps = this.approvalSteps;
            const done = [...steps].reverse().find((r) => [2, 3].includes(Number(r.lad_status)));
            if (this.statusKey === "success" || this.statusKey === "danger") {
                if (!done) return this.statusKey === "success" ? "This request has been approved." : "This request has been rejected.";
                const t = this.fmtTime(done.lad_updated_at);
                return `by ${this.approverName(done, steps.indexOf(done))}${t ? " · " + t : ""}`;
            }
            return this.currentApproverName ? `Waiting for ${this.currentApproverName}` : "Waiting for approval";
        },
        timelineSteps() {
            const steps = this.approvalSteps;
            const finished = this.statusKey === "success" || this.statusKey === "danger";
            if (!steps.length) {
                // ไม่มีข้อมูลรายขั้น -> แสดงตามสถานะรวม
                if (this.statusKey === "success")
                    return [{ title: "Approved", sub: "Request approved", icon: "mdi-check", iconColor: "#FFFFFF", dotClass: "rq-tl-ok", remark: this.leave_data.description_approve }];
                if (this.statusKey === "danger")
                    return [{ title: "Rejected", sub: "Request rejected", icon: "mdi-close", iconColor: "#FFFFFF", dotClass: "rq-tl-bad", remark: this.leave_data.description_approve }];
                return [{ title: "Pending review", sub: "Waiting for approval", icon: "mdi-clock-outline", iconColor: "#FFFFFF", dotClass: "rq-tl-current" }];
            }
            let currentFound = false;
            const out = [];
            steps.forEach((r, i) => {
                const name = this.approverName(r, i);
                const st = Number(r.lad_status);
                if (st === 2) {
                    out.push({ title: "Approved", sub: `by ${name}`, time: this.fmtTime(r.lad_updated_at), remark: r.remark_detail, icon: "mdi-check", iconColor: "#FFFFFF", dotClass: "rq-tl-ok" });
                } else if (st === 3) {
                    out.push({ title: "Rejected", sub: `by ${name}`, time: this.fmtTime(r.lad_updated_at), remark: r.remark_detail, icon: "mdi-close", iconColor: "#FFFFFF", dotClass: "rq-tl-bad" });
                } else if (!finished) {
                    if (!currentFound) {
                        currentFound = true;
                        out.push({ title: "Pending review", sub: `Waiting for ${name}`, icon: "mdi-clock-outline", iconColor: "#FFFFFF", dotClass: "rq-tl-current" });
                    } else {
                        out.push({ title: "Next approver", sub: name, icon: "mdi-account-outline", iconColor: "#9CA3AF", dotClass: "rq-tl-next" });
                    }
                }
                // ใบลาจบแล้ว (อนุมัติ/ปฏิเสธ) ขั้นที่ยังเป็น 1 ไม่ต้องแสดง
            });
            return out;
        },
        initials() {
            const parts = String(this.fullName || "").trim().split(/\s+/).filter(Boolean);
            if (!parts.length) return "?";
            return ((parts[0][0] || "") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
        },
        computedDateFromFormatted() {
            return unity.formatDate(this.leave_data.startDate);
        },
        computedDateToFormatted() {
            return unity.formatDate(this.leave_data.endDate);
        },
    },
    async beforeCreate() {
        this.$store.state.navMenu = true;
    },
    async mounted() {
        await api.checkVersion();
        this.$store.state.global_dialog_push = false;
        this.$store.state.global_dialog = false;

        this.userId = localStorage.getItem(server.USER_ID);

        await this.loadDataLeave();
        this.$hideLoader();
    },

    methods: {
        async closeDelete() {
            this.dialogDelete = false;
        },
        async getBackList() {
            if (this.$route.params.mode == "approverhistory") {
                this.$router.push(`/approver-time-off-history`);
            } else {
                this.$router.push(`/my-time-off`);
            }

        },
        async loadDataLeave() {
            const res_leave = await api.getLeaveHistoryByIDWaiting(this.$route.params.id)
            this.requestRaw = (res_leave.data && res_leave.data[0]) || {};
            this.waitingRows = res_leave.data || [];
            console.log("res_leave.data: ")
            console.log(res_leave.data)

            this.leave_data.leaveTypeId = res_leave.data[0].leave_name;
            this.day_select = res_leave.data[0].type_count;
            this.leave_data.startDate = res_leave.data[0].startdate_s;
            this.leave_start_hours = Number(res_leave.data[0].starthour);
            this.leave_data.endDate = res_leave.data[0].enddate_s;
            this.leave_end_hours = res_leave.data[0].endhour;
            this.leave_data.description = res_leave.data[0].description;
            this.leave_data.description_approve = res_leave.data[0].remark_detail;
            this.leave_data.status_approve_name = res_leave.data[0].approve_name;
            this.str_m_time = res_leave.data[0].t_startdate_s;
            this.end_m_time = res_leave.data[0].t_enddate_s;

            var amount = 0;
            var leave_day = 0;
            var leave_hours = 0;

            amount = Number(res_leave.data[0].amount) / 60;
            leave_day = Math.floor(amount / 8);
            leave_hours = amount - (leave_day * 8);

            this.amountShow = `${leave_day} day ${leave_hours} hours`;
            this.amountHours = amount;

            let setiamggfile = res_leave.data[0].preview_image
                ? res_leave.data[0].preview_image.split(",")
                : [];
            if (setiamggfile[0] == "") {
            } else {
                setiamggfile.forEach((x) => {
                    this.oldpreview_list.push(`${imageUrl}/${x}`);
                });
            }
            // ===== ชื่อและรูปพนักงาน =====
            this.image_show = res_leave.data[0].image;

            if (res_leave.data[0].image == "" || res_leave.data[0].image == null) {
                this.leave_data.images = imageUrl + "/personal.png";
            } else {
                this.leave_data.images = imageUrl + "/" + res_leave.data[0].image;
            }

            if (res_leave.data[0].fullname_eng && res_leave.data[0].fullname_eng.trim() !== "") {
                this.fullName = res_leave.data[0].fullname_eng;
            } else {
                this.fullName = res_leave.data[0].fullname;
            }

        },
        // ===== UI helpers (ใหม่) =====
        // รองรับ YYYY-MM-DD / DD/MM/YYYY / ISO -> 7 Sep 2026
        displayDate(value) {
            if (!value) return "-";
            const s = String(value).trim();
            let m = /^\d{2}\/\d{2}\/\d{4}/.test(s) ? moment(s.substring(0, 10), "DD/MM/YYYY") : moment(s);
            return m.isValid() ? m.format("D MMM YYYY") : s;
        },
        approverName(r, i) {
            const en = String(r.approver_name_eng || "").trim();
            const th = String(r.approver_name_th || "").trim();
            return en || th || `Approver level ${i + 1}`;
        },
        fmtTime(v) {
            if (!v) return "";
            const m = moment(v);
            return m.isValid() ? m.format("D MMM YYYY, HH:mm") : "";
        },
        hoursText(v) {
            const o = this.leave_hours.find((x) => Number(x.value) === Number(v));
            return o ? o.text : "-";
        },
        exportToPDF() {
            this.$refs.html2Pdf.generatePdf();
        },
        setupAlertDialog(status, title, message, text_color) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
        },
        setupAlertDialogPush(status, title, message, text_color, link) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
            this.link = link;
        },
        previewMultiImage: function (event) {
            var input = event.target;
            var count = input.files.length;
            var index = 0;
            if (input.files) {
                while (count--) {
                    var reader = new FileReader();
                    reader.onload = (e) => {
                        this.preview_list.push(e.target.result);
                    };
                    if (input.files[index].type.split("/")[0] === "image") {
                        this.image_list.push(input.files[index]);
                        reader.readAsDataURL(input.files[index]);
                    }
                    index++;
                }
            }
        },
        deleteItemConfirm(imageurl) {
            // this.indeximage = index;
            this.imageshowpopup = imageurl;
            this.dialogDelete = true;
        },
    },
};
